/**
 * Purpose: Thread view component that displays comments/replies for a specific message
 *
 * How it works:
 * 1. Displays when activeThreadId is set in navigation state
 * 2. Shows the thread header with original message context
 * 3. Renders a list of comments/replies to the thread
 * 4. Conditionally shows RTF input based on allowThreads setting
 *
 * Key features:
 * - Full-screen overlay on mobile (z-50)
 * - Thread-specific comment list with loading state
 * - Conditional input visibility based on activeChatAllowThreads
 * - Attachment viewer integration for media in comments
 * - Early return if no active thread selected
 */

import BottomSpacer from "@/components/shared/BottomSpacer";
import { useNavigationState } from "@/zustand/NavigationState";

import RtfInput from "./rtfInput/RtfInput";

import ThreadPlaygroundHeader from "./ThreadPlaygroundHeader";
import ThreadCommentList from "./messages/ThreadCommentList";
import ThreadCommentListLoading from "./messages/ThreadCommentListLoading";
import { useDragDrop } from "./rtfInput/hooks/useDragDrop";
import DragDropOverlay from "./DragDropOverlay";

export default function ThreadPlayground() {
  // global state references
  // const activeChatId = useNavigationState((state) => state.activeChatId);
  const activeThreadId = useNavigationState((state) => state.activeThreadId);
  const activeChatAllowThreads = useNavigationState(
    (state) => !!state.activeChatAllowThreads,
  );
  // fetch the active thread message
  // TO DO => refactor into global state hook (similar with nav state refactor)

  const { isDragging, dragHandlers } = useDragDrop();

  if (!activeThreadId) {
    return null;
  }

  return (
    <div
      className="absolute inset-0 z-50 flex size-full flex-col overflow-hidden bg-background lg:border-l lg:border-border"
      {...dragHandlers}
    >
      <DragDropOverlay isDragging={isDragging} />
      <ThreadPlaygroundHeader />

      <ThreadCommentListLoading>
        <ThreadCommentList />
      </ThreadCommentListLoading>

      <div className="min-h-middleColumnFooterHeight flex w-full flex-col px-4 py-2">
        <div className="flex w-full flex-col space-y-2 lg:mx-auto lg:max-w-[1000px]">
          {/* TO DO => improve logic and handle deleted members */}
          {/* TO DO => improve logic on 2 instances of same RTF INPUT */}
          {activeThreadId && activeChatAllowThreads && <RtfInput />}
        </div>

        <BottomSpacer />
      </div>
    </div>
  );
}
